import { createMessage } from 'panel/conversation/redux/actions'
import { Dispatch } from 'redux'
import { MessageAttachmentType, StorageItemRefType, uploadFile } from 'util/services/upload'

export const uploadConversationFiles = (props: UploadFilesProps) => {
  const { files, conversationId, storeId, message, type, sendType } = props
  return async (dispatch: Dispatch) => {
    const totalFiles = files.length
    let lastProgress = 0
    const uploadedPercentage: { [key: number]: number } = {}

    const interval = setInterval(() => {
      const total = Object.values(uploadedPercentage).reduce((a, b) => a + b, 0)
      const progress = Math.round(total / totalFiles)
      if (progress !== lastProgress) {
        lastProgress = progress
        props.onProgress?.(progress)
      }
    }, 500)

    await Promise.all(files.map(async (item, i) => {
      const location = await uploadFile({
        file: item.file,
        mimeType: item.file.type,
        location: 'conversation/attachment',
        refId: String(conversationId),
        refType: StorageItemRefType.MESSAGE_ATTACHMENT,
        storeId,
        originalFileName: item.file.name,
        onUploadProgress: (progress) => {
          uploadedPercentage[i] = progress
          console.log({ i, progress })
        }
      })

      const formData = new FormData()
      if (i === 0 && message) formData.set('message', message)
      if (sendType) formData.set('sendType', sendType)

      const url = new URL(location)
      const key = url.pathname.substring(1)

      formData.set('attachment[key]', key)
      formData.set('attachment[type]', type)
      formData.set('attachment[originalname]', item.file.name)

      await createMessage(storeId, conversationId, formData)(dispatch)
    }))

    clearInterval(interval)
  }
}

type UploadFilesProps = {
  storeId: number
  conversationId: number

  message?: string
  sendType?: string

  files: Array<{ uri: string, name: string, file: File }>,
  type: MessageAttachmentType,
  onProgress?: (progress: number) => void
}
